import { render } from "./a-camera-modal.vue?vue&type=template&id=cb871bfc&scoped=true&ts=true"
import script from "./a-camera-modal.vue?vue&type=script&lang=ts"
export * from "./a-camera-modal.vue?vue&type=script&lang=ts"

import "./a-camera-modal.vue?vue&type=style&index=0&id=cb871bfc&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb871bfc"]])

export default __exports__